<template>
    <fragment>
        <div class="home-bg">

            <div id="header-container">
                <div class="bg-image">
                    <img :src="'https://fabricfour.blob.core.windows.net/mhslearning-upload/' + this.siteDesign.homePage.bannerFileName" alt="Alternate Text" />
                </div>
                <div class="banner-container animate__animated animate__zoomIn banner-bg-tr">
                    <div class="banner-title accent-primary-tx" v-if="siteDesign && siteDesign.homePage" v-html="siteDesign.homePage.title"></div>
                    <div class="banner-subtitle accent-primary-tx" v-if="siteDesign && siteDesign.homePage">{{siteDesign.homePage.subtitle}}</div>
                    <div class="banner-contact text-white pb-5 mt-0" v-if="siteDesign.homePage.showContactInfo">
                        <i class="fa fa-phone" aria-hidden="true"></i> {{siteDesign.footer.contactNumber}}
                        <br />
                        <a href="#" class="text-white sl-email">
                            <i class="fa fa-envelope" aria-hidden="true"></i> {{siteDesign.footer.email}}
                        </a>
                    </div>
                </div>
            </div><!-- flat-slider -->
            <div class="row">
                <div class="col">
                    <div class="row">
                        <div class="col-lg-1 d-none d-lg-block">

                        </div>
                        <div class="col-lg-10 col-12">
                            <div class="content-introduce content-introduce-style1 pl-4 pr-4 ml-4 mr-4">
                                <div class="title-section">
                                    <p class="sub-title lt-sp25 main-title-text" style="font-size: 16px; font-weight: 700;">{{siteDesign.introTitle}}</p>
                                    <div class="flat-title larger">{{siteDesign.introSubtitle ? siteDesign.introSubtitle : "Get started today"}}</div>
                                    <div class="accent-primary-bd-bottom" style="width: 100%; padding-bottom: 10px;"></div>
                                </div>
                                <div class="content-introduce-inner">
                                    <p class="home-tx">
                                        {{siteDesign.introDescription}}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-1 d-none d-lg-block">

                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-12" v-if="!isAuthenticated">
                    <div class="iconbox-style1 mr-4">
                        <login-component></login-component>
                    </div>
                </div>
            </div>
            <div class="row components-wrapper home-bg">
                <div class="col-12">
                    <div class="row" v-for="(component, index) in siteDesign.components">
                        <div class="col-12">

                            <div v-if="component.type == 'text'" class="component-wrapper">
                                <div class="component-alignment d-flex">
                                    <div class="component-size home-bg home-tx pt-4 pb-4" v-bind:class="{componentSmall: component.size == 'small', componentMedium: component.size == 'medium', componentLarge: component.size == 'large',componentLeft: component.alignment == 'left', componentCenter: component.alignment == 'center', componentRight: component.alignment == 'right', }" style="margin: 0 auto;">
                                        <div class="container-fluid content" v-html="component.text">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="component.type == 'html'" class="component-wrapper">
                                <div class="component-alignment d-flex">
                                    <div class="component-size home-bg home-tx pt-4 pb-4" v-bind:class="{componentSmall: component.size == 'small', componentMedium: component.size == 'medium', componentLarge: component.size == 'large',componentLeft: component.alignment == 'left', componentCenter: component.alignment == 'center', componentRight: component.alignment == 'right', }" style="margin: 0 auto;">
                                        <div class="container-fluid content" v-html="component.html">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="component.type == 'course' && component.courses" class="component-wrapper">
                                <section class="online-courses online-courses-style1 bg-home ml-5 mr-5" style="padding-top: 50px">
                                    <div class="title-section text-center">
                                        <div class="flat-title medium" v-if="component.courses.length > 1">
                                            Browse our range of courses
                                        </div>
                                        <div class="flat-title medium" style="padding-bottom: 20px;" v-if="component.courseSelection == 'featured'">
                                            {{component.courses.length > 1 ? "Featured Online Courses" : "Featured Course"}}
                                        </div>
                                    </div>
                                    <div class="online-courses-wrap">
                                        <div class="row">
                                            <div class="col-12 d-flex justify-content-center flex-wrap">
                                                <featured-course-card-component v-show="component.courses" v-for="course in component.courses" :course="course" :key="course.id" style="flex: 1 0 30%; max-width: 500px; margin-left: auto; margin-right: auto;" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="browse-all-courses pd-browse-course text-center">
                                        <router-link class="btn-browse-courses btn-site-primary" v-if="!nextComponentIs(index, 'course')" to="/courses">Browse all courses</router-link>
                                    </div>
                                </section>
                            </div>
                            <div v-if="component.type == 'coursePackage'" v-for="coursePackage in component.coursePackages" :key="coursePackage.id">
                                <course-package-component v-show="component.coursePackages" :coursePackage="coursePackage" :component="component" />
                            </div>
                            <div v-if="component.type == 'tiles'" class="component-wrapper tiles-wrapper">
                                <div class="title-section d-flex">
                                    <div class="flat-title small">
                                        {{component.title}}
                                    </div>
                                    <div class="accent-secondary-bd-bottom ml-4" style="width: 50px;"></div>
                                </div>
                                <div class="row">
                                    <div class="col ml-auto mr-auto tile-col" v-show="component.tiles.length > 0" v-for="tile in component.tiles">
                                        <article class="post post-style2 accent-primary-bs-card text-center pb-2 mb-3 h-100">
                                            <div class="featured-post">
                                                <!--fix-->
                                                <img :src="tile | s3url('image')" style="height: 300px;">
                                            </div>
                                            <div class="post-content" style="">
                                                <div class="category d-flex mt-2 text-left ml-4" style="font-size: 18px; font-weight: 500; color: #fbb545;">
                                                    {{tile.title}}
                                                    <div class="accent-secondary-bd-bottom ml-3 mb-1" style="width: 20px;"></div>
                                                </div>
                                                <div class="post-title text-left ml-4 mt-3 mb-3">
                                                    <h5>
                                                        <a target="_blank" v-if="tile.url" :href="getCleanUrl(tile.url)" class="text-dark" style="font-size: 33px; font-weight: 500; overflow-wrap: break-word;" v-bind:style="{fontSize: tile.fontSize ? getFontSize(tile.fontSize) : getFontSize('default')}">
                                                            {{tile.subtitle}}
                                                        </a>
                                                    </h5>
                                                </div>
                                                <div class="post-link text-left">
                                                    <a class="ml-4" target="_blank" :href="getCleanUrl(tile.url)" style="font-size: 20px;">
                                                        Read Now
                                                    </a>
                                                </div>
                                            </div>
                                        </article>
                                    </div>
                                </div>
                            </div>
                            <div v-if="component.type == 'features'" class="component-wrapper">
                                <div class="wrap-inconbox-benefit pt-4 pb-4" :style="{backgroundColor: component.backgroundColor}">
                                    <div class="title-section d-flex justify-content-center text-center">
                                        <div class="flat-title small accent-primary-tx">{{component.title}}</div>
                                        <div class="accent-primary-bd-bottom ml-4" style="width: 0px;"></div>
                                    </div>
                                    <div class="iconbox-benefit iconbox-benefit-style1">
                                        <div class="row">
                                            <div class="col-12 d-flex flex-wrap justify-content-center pl-5 pr-5">
                                                <div class="ml-4 mr-4 feature-col" v-for="feature in component.features">
                                                    <div class="themesflat-content-box" data-padding="0% 4% 0% 0%" data-sdesktoppadding="0% 15px 0% 0%" data-ssdesktoppadding="0% 15px 0% 0%" data-mobipadding="0% 0% 0% 0%" data-smobipadding="0% 0% 0% 0%">
                                                        <div class="iconbox text-center">
                                                            <div class="iconbox-icon" v-if="feature.imageType == 'file'">
                                                                <img :src="feature | s3url('image')" alt="image" :class="{imgSmall: feature.imageSize == 'small', imgMedium: feature.imageSize == 'medium', imgLarge: feature.imageSize == 'large'}" />
                                                            </div>
                                                            <div class="iconbox-icon">
                                                                <i v-bind:class="getIconClass(feature.iconSize, feature.icon)" v-bind:style="{color: feature.iconColor}"></i>
                                                            </div>
                                                            <div class="iconbox-content img-four">
                                                                <h3 class="accent-primary-tx" v-if="feature.title">{{feature.title}}</h3>
                                                                <p class="accent-primary-tx">
                                                                    {{feature.description}}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="component.type == 'video'" class="component-wrapper">
                                <div class="wrap-inconbox-benefit pt-5 pb-5" style="text-align: center">
                                    <div class="title-section">
                                        <div class="flat-title small heading-type2" style="color: #3d3c79 ">{{component.title}}</div>
                                    </div>
                                    <div v-if="component.videoType == 'url'">
                                        <div v-if="component.videoSize == 'card'">
                                            <iframe class="iframe-wrapper" style="width: 80%; height: 60vh;" :src="getEmbedURL(component.videoURL)" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                        </div>
                                        <div v-else>

                                            <iframe style="width: 100%; height: 60vh;" :src="getEmbedURL(component.videoURL)" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <video width="90%" height="" style="max-width: 2560px;" :src="component | s3url('video')" controls></video>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <!--feature list-->
            <!--<section class="flat-benefit style1 clearfix">

            </section>-->
            <!--tiles component-->
            <!--<section class="latest-blog latest-blog-type2 latest-blog-style2">

            </section>-->

        </div>
    </fragment>
</template>

<style>
    .iframe-wrapper {
        margin: 0px 50px 100px 50px;
        box-shadow: rgb(0 0 0 / 25%) 0px 14px 28px, rgb(0 0 0 / 22%) 0px 10px 10px;
        border-radius: 15px;
    }

    .imgSmall {
        max-width: 100px;
    }

    .imgMedium {
        max-width: 200px;
    }

    .imgLarge: {
        max-width: 300px;
    }

    @media screen and (min-width: 2300px) {
        .banner-title {
            font-size: 2vw !important;
        }

        .banner-subtitle {
            font-size: 1vw !important;
        }
    }

    .invert {
        mix-blend-mode: difference;
    }

    .component-wrapper {
        padding: 70px 0;
    }

    .page-component {
        margin: 10px;
        padding: 10px;
    }

    .componentSmall {
        width: 50%;
    }

    .componentMedium {
        width: 75%;
    }

    .componentLarge {
        width: 100%;
    }

    .componentLeft {
        text-align: left;
    }

    .componentCenter {
        text-align: center;
    }

    .componentRight {
        text-align: right;
    }

    .news-btn {
        color: #fbb545;
    }

        .news-btn:hover {
            color: orange;
        }

    #header-container {
        overflow: hidden;
        position: relative;
        background-size: cover;
        background-position: center;
    }

    .bg-image {
        position: absolute;
        width: 100%;
        height: 100%;
    }

    .bg-image img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .banner-container {
        padding-left: 10%;
        padding-top: 100px;
    }

    .banner-title {
        font-size: 3.8vw;
        font-weight: 700;
        margin-right: 80px;
        max-width: 900px;
    }

    .banner-subtitle {
        margin-top: 3vw;
        font-size: 1.8vw;
        font-weight: 700;
        max-width: 60%;
        padding-bottom: 100px;
    }

    .banner-contact {
        margin-top: 2.5vw;
        font-size: 2vw !important;
    }

    .tiles-wrapper {
        padding: 80px 175px;
    }

    .tile-col {
        min-width: 300px;
        max-width: 400px;
    }

    .feature-col {
        min-width: 300px;
        max-width: 450px;
    }

    @media (max-width: 767px) {
        .banner-title {
            margin-right: 0;
        }

        .tiles-wrapper {
            padding: 40px 16px;
        }

        .tile-col, .feature-col {
            min-width: 0;
            max-width: 100%;
            flex: 0 0 100%;
        }
    }
</style>
<script>

    import CourseCardComponent from "../components/CourseCardComponent";
    import FeaturedCourseCardComponent from "../components/FeaturedCourseCardComponent";
    import LoginComponent from "../components/LoginComponent";

    export default {
        name: 'Home',
        components: {
            CourseCardComponent,
            FeaturedCourseCardComponent,
            "login-component": LoginComponent
        },
        props: {

        },
        watch: {
        },
        computed: {
            isAuthenticated() {
                return this.$store.state.isAuthenticated;
            },
        },
        data() {
            return {
                siteDesign: null,
                coursePackages: [],
            }
        },
        methods: {
            addAlpha(color, opacity) {
                var _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
                return color + _opacity.toString(16).toUpperCase();
            },
            getFontSize(size) {
                switch (size) {
                    case "small":
                        return "14px";
                        break;
                    case "medium":
                        return "20px";
                        break;
                    case "large":
                        return "25px";
                        break;
                    default:
                        return "14px";
                        break;
                }
            },
            getIconClass(size, icon) {
                var str = size + " " + icon;
                return str;
            },
            nextComponentIs(componentIndex, type) {
                var nextIndex = componentIndex + 1;
                if (this.siteDesign.components[nextIndex]) {
                    var nextComponent = this.siteDesign.components[nextIndex];
                    if (nextComponent.type == type) {
                        return true;
                    }
                }
                return false;
            },
            getEmbedURL(url) {
                return url.replace("https://www.youtube.com/watch?v=", "https://www.youtube.com/embed/");
            },
            getCleanUrl(url) {
                //append http if does not have it
                if (url) {
                    var clean = url;
                    if (!url.includes("http") || !url.includes("https")) {
                        clean = "http://" + url;
                        clean = "http://" + url;
                    }
                    return clean;
                }
            },
        },
        async beforeMount() {
            //this.courses = await this.web("/courses?filters=promoted");
            //this.coursePackages = await this.web("/coursePackages");
            var design = this.$store.getters.getSiteDesign;
            this.siteDesign = design;
            this.$store.commit("breadCrumbs", null);
        },
        async mounted() {
            //$("#page-top").css("background-image", "url(https://fabricfour.blob.core.windows.net/mhslearning-upload/" + this.siteDesign.homePage.bannerFileName + ")");
        },

    }

</script>


